import { render, staticRenderFns } from "./OrderItemStatusManager.vue?vue&type=template&id=772a9a04"
import script from "./OrderItemStatusManager.vue?vue&type=script&lang=js"
export * from "./OrderItemStatusManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports